<template>
  <div class="contai">
    <h1>About</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
